(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsRecruitmentRateDetail', rmsRecruitmentRateDetail);

    function rmsRecruitmentRateDetail() {
        return {
            restrict: 'E',
            controller: rmsRecruitmentRateDetailCtrl,
            scope: {
                options: '=',
                model: '=',
                getModel: '=',
            },
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'rms/templates/company/recruitment-rate-details',
        };
    }

    function rmsRecruitmentRateDetailCtrl(lodash, QB_CONSTANTS) {
        var vm = this;
        this.$onInit = function() {
            vm.getModel = getModel;

            init();
        }

        function init() {
            if (lodash.has(vm.options, 'detail_form')) {
                vm.detail_form_model = vm.model.detail_form;
            }
            if (lodash.has(vm.options, 'charges_form')) {
                vm.charge_form_model = vm.model.charge_form;
            }

            vm.queryBuilder = {};
            // vm.columns = ['FirstName', 'LastName', 'Age', 'Gender', 'DOB', 'Major', 'School'];
            vm.columns = [
                {
                    'label': 'First Name',
                    'identifier': 'first_name'
                },
                {
                    'label': 'Last Name',
                    'identifier': 'last_name'
                },
                {
                    'label': 'Age',
                    'identifier': 'age'
                },
            ];
            vm.queryBuilderOptions = {
                expressionValuePrefix: '@',
                jointOperators: ['+', '-', '*', '/'],
                showBrackets: false,
                mode: QB_CONSTANTS.EQUATION_MODE,
                allowCustomQuery: QB_CONSTANTS.DISALLOW_CUSTOM_QUERY
            };
        }

        function getModel() {
            var detailFormModel = {}, chargeFormModel = {};
            if (lodash.has(vm.options, 'detail_form')) {
                detailFormModel = vm.getDetailFormModel();
            }
            if (lodash.has(vm.options, 'charges_form')) {
                chargeFormModel = vm.getChargesFormModel();
            }

            return angular.merge(vm.model, {'detail_form':detailFormModel}, {'charge_form':chargeFormModel});
        }
    }
})();